import { type ReactNode } from 'react'
import { type DefaultTheme } from 'styled-components'
import FlexContainer from './Flex.styles'

export interface FlexProps {
  center?: boolean
  baseline?: boolean
  column?: boolean
  row?: boolean
  wrap?: boolean
  justify?: string
  align?: string
  children: ReactNode
  marginTop?: number
  marginBottom?: number
  marginLeft?: number
  marginRight?: number
  maxWidth?: number
  color?: keyof DefaultTheme['colors']
}

function Flex({
  children,
  center,
  baseline,
  column,
  row,
  wrap,
  justify,
  align,
  ...otherProps
}: FlexProps) {
  return (
    <FlexContainer
      $center={center}
      $baseline={baseline}
      $column={column}
      $row={row}
      $wrap={wrap}
      $justify={justify}
      $align={align}
      {...otherProps}
    >
      {children}
    </FlexContainer>
  )
}

export default Flex
